import { lazy, Suspense } from 'react';
import { Route } from 'react-router-dom';
import SkeletonPage from '../modules/skeleton/SkeletonPage';
import InsuranceCreate from '../modules/asset-management/pages/InsuranceCreate';
import AssetUsers from '../modules/asset-management/pages/AssetUsers';
import InsuranceView from '../modules/asset-management/pages/InsuranceView';

const Dashboard = lazy(() => import('../modules/asset-management/pages/Dashboard'));
const AssetList = lazy(() => import('../modules/asset-management/pages/AssetList'));
const InsuranceList = lazy(() => import('../modules/asset-management/pages/InsuranceList'));
const MyAssets = lazy(() => import('../modules/asset-management/pages/MyAssets'));
const Setting = lazy(() => import('../modules/asset-management/pages/Setting'));
const AssetCreate = lazy(() => import('../modules/asset-management/pages/AssetCreate'));
const AssetChildEdit = lazy(() => import('../modules/asset-management/pages/AssetChildEdit'));
const AssetView = lazy(() => import('../modules/asset-management/pages/AssetView'));
const AssetGroupView = lazy(() => import('../modules/asset-management/pages/AssetGroupView'));
const AddExpense = lazy(() => import('../modules/asset-management/pages/AddExpense'));

const AssetManagementRoutes = (
  <>
    <Route
      path="asset-management/dashboard"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Dashboard />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset-list"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetList />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset/create"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetCreate />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset/:id/view"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetView />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset/:id/edit"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetChildEdit />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset-group/:id/view"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetGroupView />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset-group/:id/edit"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetCreate />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset/:id/add-expense"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AddExpense />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset/:id/edit-expense/:expenseId"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AddExpense />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset-group/:groupId/add-expense"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AddExpense />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset-group/:groupId/edit-expense/:expenseId"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AddExpense />
        </Suspense>
      }
    />
    <Route
      path="asset-management/insurance-list"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InsuranceList />
        </Suspense>
      }
    />
    <Route
      path="asset-management/insurance/create"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InsuranceCreate />
        </Suspense>
      }
    />
    <Route
      path="asset-management/insurance/:id/edit"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InsuranceCreate />
        </Suspense>
      }
    />
    <Route
      path="asset-management/insurance/:id/view"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <InsuranceView />
        </Suspense>
      }
    />
    <Route
      path="asset-management/my-assets"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <MyAssets />
        </Suspense>
      }
    />
    <Route
      path="asset-management/asset-users"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <AssetUsers />
        </Suspense>
      }
    />
    <Route
      path="asset-management/setting"
      element={
        <Suspense fallback={<SkeletonPage />}>
          <Setting />
        </Suspense>
      }
    />
  </>
);

export default AssetManagementRoutes;
